import '.hg{margin:auto 4px;}.ssr-plugin'
import '.hh{height:calc(100% - 8px );}.ssr-plugin'
import '.hi{width:1px;}.ssr-plugin'
import '.hj{z-index:0;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.hk{padding:2px 8px 2px 8px;}.ssr-plugin'
import '.hl{height:5px;}.ssr-plugin'
import '.ab{height:1px;}.ssr-plugin'
import '.hm{width:2px;}.ssr-plugin'
import '.hn{height:2px;}.ssr-plugin'
import '.ho{margin:auto 8px;}.ssr-plugin'
import '.b6{display:inline-block;}.ssr-plugin'
import '.ec{border-radius:4px;}.ssr-plugin'
import { colors } from '../../tokens/colors.js'
import { Style, styled } from 'inlines'

type SeparatorProps = {
  orientation?: 'horizontal' | 'vertical'
  variant?: 'line' | 'dot'
  style?: Style
}

function Separator({
  orientation = 'horizontal',
  variant = 'line',
  style,
}: SeparatorProps) {
  if (variant === 'line') {
    if (orientation === 'vertical') {
      return (
        <styled.div className="hg hh hi hj"
          style={{
            background: colors.neutral10,
            ...style,
          }}
        />
      )
    }
    return (
      <styled.div className="h hk hl"
        style={{
          ...style,
        }}
      >
        <div className="ab h"
          style={{ background: colors.neutral10 }}
        />
      </styled.div>
    )
  } else {
    return (
      <styled.div className="hm hn ho b6 ec hj"
        style={{
          background: colors.neutral60,
          // margin:'auto 6px',
          ...style,
        }}
      />
    )
  }
}

export { Separator }
export type { SeparatorProps }
